<template>
  <div class=''>

        <div class="col">
            <h3>Visão Geral de Campanha</h3>
            <table id="relAnalitic" ref='tabela' class="table display table-hover table-striped" style="width:100%;">
                <thead></thead>
                <tbody></tbody>
                <tfoot></tfoot>
            </table>
        </div>
  </div>
</template>

<script>
export default {
    props:{
        filter: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            dt: null,
            val: this.filter
        }
    },
    watch:{
        filter: {
            handler: function(val){
                this.createTable()
            },
            deep: true
        }
    },
    methods:{
        createTable(){

            if (this.dt){
                $('#relAnalitic').DataTable().destroy();
            }

            this.dt = $('#relAnalitic').DataTable({
                ajax:{
                    url: '/marketing/analise',
                    data: { param: this.filter },
                    dataSrc: ''
                },
                columns: [
                {
                    data: 'created_at',
                    class: 'tamanho',
                    title: 'Data da campanha',
                    render: (data) => {
                        if(!data) return ''
                        return moment(data).format('DD/MM/YYYY HH:mm:ss')
                    }
                },    
                {
                    data: 'nome_campanha',
                    title: 'Campanha',
                    class: 'text-center'
                },
                {
                    data: 'Pendente',
                    class: 'text-center',
                    title: 'Pendente'
                },
                {
                    data: 'Enviado',
                    class: 'text-center',
                    title: 'Enviado'
                },
                {
                    data: 'Recebido',
                    class: 'text-center',
                    title: 'Recebido'
                },
                {
                    data: 'Lido',
                    class: 'text-center',
                    title: 'Lido'
                },
                {
                    data: 'Nao-Entregue',
                    class: 'text-center',
                    title: 'Falha'
                },
                {
                    data: "total",
                    class: 'text-center',
                    title: 'Progresso campanha',
                    render: (_,__,row) => {
                        const total = row['Pendente'] + row['Enviado'] + row['Recebido'] + row['Lido'] + row['Nao-Entregue']
                        const progresso = Math.round(((total - row['Pendente'] )/ total)  * 100);
                        return progresso + '%'
                    }
                }]
            })

            this.dt.buttons('.dtUpdateButton').remove();

        }
    },
    mounted(){
        this.createTable();

    }

}
</script>

<style scoped>
.bg-purple{
    background-color: purple;
}
.size-tabela{
    width: 700px;
}

</style>